import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, InjectionToken } from '@angular/core';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { appThemePreset } from './core/theme/app-theme.preset';
import { authInterceptor } from './core/http/auth.interceptor';
import { errorInterceptor } from './core/http/error.interceptor';
import { successInterceptor } from './core/http/success.interceptor';
import { AuthSessionFacade } from './core/auth/auth-session.facade';
import { AppConfigService } from './core/config/app-config.service';

import { routes } from './app.routes';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export function apiBaseUrlFactory(): string {
  return inject(AppConfigService).apiBaseUrl;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, successInterceptor, errorInterceptor])
    ),
    { provide: API_BASE_URL, useFactory: apiBaseUrlFactory },
    MessageService,
    providePrimeNG({
      theme: {
        preset: appThemePreset,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark',
          cssLayer: false,
        },
      },
    }),
    provideAppInitializer(() => {
      const authFacade = inject(AuthSessionFacade);
      authFacade.restoreSession();
    }),
  ],
};
